import {ClientAfipActivity, ClientAfipActivityFields} from "../../../../../types/client/clientData";
import {useFormContext} from "react-hook-form";
import {Alert, Grid, MenuItem, Skeleton, Stack, Typography, useTheme} from "@mui/material";
import {FontInputData, FontSubtitleTwo} from "../../../components/SharedTypography";
import Divider from "@mui/material/Divider";
import {ControlledTextFieldFilled} from "../../../../../components/forms";
import React, {useEffect, useState} from "react";
import controlledTextFieldStyles from "../../../../../components/forms/ControlledTextField.styles";
import Chip from "@mui/material/Chip";
import {SolicitationFields} from "../../../../../types/solicitation/solicitationData";
import {stringFormatter} from "../../../../../utils/formatters/stringFormatter";


interface CompanySolicitationActivityProps {
    activities?: ClientAfipActivity[]
}


const CompanySolicitationActivity = ({activities} : CompanySolicitationActivityProps) => {
    const theme = useTheme();
    const classes = controlledTextFieldStyles(theme);
    const { control, watch, setValue } = useFormContext()
    const watchActivity = watch(SolicitationFields.AfipActivityCode)
    const [selectedAct, setSelectedAct] = useState<ClientAfipActivity>()
    
    const renderActivities = (options: ClientAfipActivity[]) => {
        return options.map((option) => (
            <MenuItem key={option[ClientAfipActivityFields.AfipActivityCode]}
                      value={option[ClientAfipActivityFields.AfipActivityCode]}
                      sx={{
                          ...classes.menuItemSelect,
                      }}
                      onClick={() => setSelectedAct(option)}
                      disableRipple
            >
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} width={1}>
                    {stringFormatter.cutIfHaveMoreThan(option[ClientAfipActivityFields.AfipActivityDesc], 72)}
                    {option[ClientAfipActivityFields.IsMainActivity] ?
                        <Chip size={'small'} color={'warning'} label={'Principal'}/>
                        :
                        <Chip size={'small'} color={'default'} label={'Secundaria'}/>
                    }
                </Stack>
            </MenuItem>
        ))
    }

    useEffect(() => {
        if (!watchActivity && activities && activities.length !== 0) {
            if (!selectedAct) {
                const mainActivity = activities.find((a) => a[ClientAfipActivityFields.IsMainActivity])
                setSelectedAct(mainActivity)
                !mainActivity ? setValue(SolicitationFields.AfipActivityCode, activities[0][ClientAfipActivityFields.AfipActivityCode])
                : setValue(SolicitationFields.AfipActivityCode, mainActivity[ClientAfipActivityFields.AfipActivityCode])
            }
        }else if (watchActivity && activities && activities.length !== 0) setSelectedAct(activities.find((a) => a[ClientAfipActivityFields.AfipActivityCode] === watchActivity))
    }, [activities, selectedAct, watchActivity]);
    
    return (
        <Stack spacing={2}>
            <FontSubtitleTwo text={'Actividad por la cual solicita el crédito'} />
            <Divider />
            {
                activities ?
                    activities.length !== 0 ?
                        <Grid container spacing={4} alignItems='center'>
                            <Grid item md={6}>
                                <ControlledTextFieldFilled options={activities}
                                                           control={control}
                                                           label={'Actividades'}
                                                           name={SolicitationFields.AfipActivityCode}
                                                           select
                                                           renderOpt={renderActivities(activities)}
                                                           fullWidth
                                />
                            </Grid>
                            {
                                selectedAct &&
                                    <Grid item md={1.5}>
                                        <Stack>
                                            <Typography variant='subtitle1' fontWeight={550}>Sector</Typography>
                                            <FontInputData text={selectedAct[ClientAfipActivityFields.AfipSectorDesc]} />
                                        </Stack>
                                    </Grid>
                            }
                            {
                                selectedAct &&
                                    <Grid item md={4.5}>
                                        <Stack>
                                            <Typography variant='subtitle1' fontWeight={550}>Rubro</Typography>
                                            <FontInputData text={selectedAct[ClientAfipActivityFields.AfipAreaDesc]} />
                                        </Stack>
                                    </Grid>
                            }
                        </Grid>
                        :
                        <Grid item xs={12}><Alert severity={'error'}>Ocurrió un error al cargar las actividades relacionadas</Alert></Grid>
                    :
                    <Skeleton height={50} />
            }
        </Stack>
    )
}


export default CompanySolicitationActivity